import React from 'react';
import { FormRowLayoutProps, FormRowsGroupLayoutProps } from 'ui-builder';

export function ShadcnFormRowLayout(props: FormRowLayoutProps) {
  return (
    <div data-testid={props.testId} className={props.className}>
      {props.children}
    </div>
  );
}

export function ShadcnFormRowsGroupLayout(props: FormRowsGroupLayoutProps) {
  return (
    <div className="space-y-5">
      {props.children}
    </div>
  );
}
